'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var revalidator = _interopDefault(require('revalidator'));

var ValidatorService =
/*#__PURE__*/
function () {
  function ValidatorService(_ref) {
    var data = _ref.data,
        validation = _ref.validation;
    this.data = data;
    this.validation = validation;
  }

  var _proto = ValidatorService.prototype;

  _proto.validate = function validate() {
    return revalidator.validate(this.data, {
      properties: this.validation
    });
  };

  return ValidatorService;
}();

exports.ValidatorService = ValidatorService;